var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTchSub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 440,
    height: 300,
    viewBox: "0 0 116.42 79.375",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -217.63)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(100.73 85.623)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.372 57.373)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.4139 0 0 2.4139 -149.3 96.072)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.10961 0 0 .10961 -155.07 -19.353)",
    d: "m1524.2 180.92-64.736 35.311 31.891 17.395c-2.336 4.8118-3.6484 10.215-3.6484 15.926 0 20.163 16.332 36.492 36.494 36.492 20.163 0 36.494-16.33 36.494-36.492 0-5.7115-1.3136-11.115-3.6504-15.928l20.123-10.977v40.666h11.77v-47.082zm0 123.37c-24.359 0-72.986 12.224-72.986 36.492v18.246h145.97v-18.246c0-24.268-48.627-36.492-72.986-36.492z",
    fill: "#d65fce",
    strokeWidth: 9.1233
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.5571 0 0 1.5571 -144.9 75.982)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.0335 0 0 2.0335 -95.678 99.822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14 2h-8c-1.1 0-1.99 0.9-1.99 2l-0.01 16c0 1.1 0.89 2 1.99 2h12.01c1.1 0 2-0.9 2-2v-12zm2 16h-8v-2h8zm0-4h-8v-2h8zm-3-5v-5.5l5.5 5.5z",
    fill: "#d65fce"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.078 0 0 1.078 -68.968 79.997)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.35 10.04c-0.68-3.45-3.71-6.04-7.35-6.04-2.89 0-5.4 1.64-6.65 4.04-3.01 0.32-5.35 2.87-5.35 5.96 0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zm-5.35 2.96v4h-4v-4h-3l5-5 5 5z",
    fill: "#e18cdc"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTchSub);
export default __webpack_public_path__ + "static/media/tch-sub.bb7e1c579d02f63d369a3a4d3613da66.svg";
export { ForwardRef as ReactComponent };